export { VpInfoBanner } from './VpInfoBanner';



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpInfoBanner/index.js